export default class ProjetoDetailsController {
  constructor($http, $q, $state, $scope, FileUploader, AuthenticationService, AuthorizationService, UIService, ProjetoService, Projeto, ProjetoEquipa, ProjetoInstituicao, ProjetoGrupoInvestigacao, ProjetoAreaInterdisciplinar, EntidadeFinanciadora, Investigador, Instituicao, GrupoInvestigacao, AreaInterdisciplinar, Papel, ProjetoEstado, ProjetoEstadoCandidatura, Impacto, ImpactoOds, Ods, Pais, ProjetoAnexo, TipoAnexo) {
    this.$http = $http;
    this.$q = $q;
    this.$state = $state;
    this.$scope = $scope;
    this.FileUploader = FileUploader;
    this.UI = UIService;
    this.user = AuthenticationService.getUser();
    this.AuthorizationService = AuthorizationService;
    this.ProjetoService = ProjetoService;
    this.loaded = false;
    this.simnao = [{ name: "Sim", value: 1 }, { name: "Não", value: 0 }];
    this.Projeto = Projeto;
    this.ProjetoEquipa = ProjetoEquipa;
    this.ProjetoInstituicao = ProjetoInstituicao;
    this.ProjetoGrupoInvestigacao = ProjetoGrupoInvestigacao;
    this.ProjetoAreaInterdisciplinar = ProjetoAreaInterdisciplinar;
    this.EntidadeFinanciadora = EntidadeFinanciadora;
    this.Investigador = Investigador;
    this.Instituicao = Instituicao;
    this.GrupoInvestigacao = GrupoInvestigacao;
    this.AreaInterdisciplinar = AreaInterdisciplinar;
    this.Papel = Papel;
    this.ProjetoEstado = ProjetoEstado;
    this.ProjetoEstadoCandidatura = ProjetoEstadoCandidatura;
    this.Impacto = Impacto;
    this.ImpactoOds = ImpactoOds;
    this.Ods = Ods;
    this.Pais = Pais;
    this.ProjetoAnexo = ProjetoAnexo;
    this.TipoAnexo = TipoAnexo;
    this.showEstadosPanel = false;

    this.loaded = false;

    // Default opt state - populate later when we have all states
    this.optElemento = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 3,
      order: "id",
      sort: "desc",
      filter: {},
      filterLayout: {}
    };
    this.elementos = null;
    this.elementosLoading = true;

    // Default opt state - populate later when we have all states
    this.optAreas = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 3,
      order: "id",
      sort: "desc",
      filter: {},
      filterLayout: {}
    };
    this.areas = null;
    this.areasLoading = true;

    // Default opt state - populate later when we have all states
    this.optInstituicao = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 3,
      order: "id",
      sort: "desc",
      filter: {},
      filterLayout: {}
    };
    this.instituicoes = null;
    this.instituicoesLoading = true;

    // Default opt state - populate later when we have all states
    this.optGrupoInvestigacao = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 3,
      order: "id",
      sort: "desc",
      filter: {},
      filterLayout: {}
    };
    this.gruposInvestigacao = null;
    this.gruposInvestigacaoLoading = true;

    // Default opt state - populate later when we have all states
    this.optImpactosOds = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 3,
      order: "id",
      sort: "desc",
      filter: {},
      filterLayout: {}
    };
    this.impactosOds = null;
    this.impactosOdsLoading = true;

    this.anexos = [];
    this.anexosLoading = true;

    this.id = $state.params.id;

    this.loadData();
    this.limit = 3;
  }

  limitTo = () => {
    if (angular.isDefined(this.limit)) {
      this.limit = undefined;
    } else {
      this.limit = 3;
    }
  };

  loadData = () => {
    this.loaded = false;
    this.Projeto.findOne({
      filter: {
        where: {
          id: this.id
        },
        include: ['criadoPor', 'atualizadoPor', 'entidadeFinanciadora', 'investigador', 'coInvestigador', 'estado', 'estadoCandidatura', 'papel', 'impacto', {
          relation: 'equipa',
          scope: {
            include: {
              relation: 'investigador',
              scope: {
                fields: {userId: true}
              }
            }
          }
        }]
      }
    }).$promise.then(res => {
      this.data = res;

      this.getImpactosOdsForImpacto(); // We can only load this after getting impactoId
      this.getElementosForProjeto();
      this.getAreasForProjeto();
      this.getInstituicoesForProjeto();
      this.getGruposInvestigacaoForProjeto();
      this.getAnexosForProjeto();

      this.loaded = true;
    }).catch((error) => {
      console.log(error);
      this.$state.go('app.projeto.list');
      this.UI.addToast('Erro ao carregar projeto. Verifique a ligação');
    });
  };

  // Edit titulo / descricao
  editTituloDescricao = () => {
    let options = {
      size: 'lg',
      template: require('./titulo.descricao.dialog.html'),
      controller: ['$scope', ($scope) => {
        $scope.label = "Editar Título e Descrição";
        $scope.projeto = angular.copy(this.data);


        $scope.ok = () => {
          $scope.$close($scope);
        };

        $scope.cancel = () => $scope.$dismiss('cancel');
      }]
    };

    this.UI.showDialog(options).then(res => {
      this.loaded = false;
      if (res) {
        this.Projeto.prototype$updateAttributes({id: this.data.id},
          {
            titulo: res.projeto.titulo,
            descricao: res.projeto.descricao || null,
            atualizadoPorId:  this.user.id,
            atualizadoa: moment().format()
          }
        ).$promise.then(() => {
          this.UI.addToast("Dados atualizados com sucesso");
          this.loadData();
        }).catch((error) => {
          console.log(error);
          this.UI.showAlert("Erro ao atualizar projeto. Verifique a ligação");
          this.loaded = true;
        });
      }
    });
  };

  editDetalhes = () => {
    let wait = this.UI.showWaiting();
    this.Investigador.find({}).$promise.then(investigadores => {
      investigadores.sort((a, b) => a.nome.localeCompare(b.nome));
      this.EntidadeFinanciadora.find({}).$promise.then(entidadesFinanciadoras => {
        this.Papel.find({}).$promise.then((papeis) => {
          this.ProjetoEstado.find({}).$promise.then((estados) => {
            this.ProjetoEstadoCandidatura.find({}).$promise.then((estadosCandidatura) => {
              wait.close();
              let options = {
                size: 'lg',
                template: require('./details.dialog.html'),
                controller: ['$scope', '$dialog', ($scope, $dialog) => {
                  $scope.label = "Editar Projeto";
                  $scope.AuthorizationService = this.AuthorizationService;
                  $scope.projeto = angular.copy(this.data);
                  $scope.investigadores = investigadores;
                  $scope.entidadesFinanciadoras = entidadesFinanciadoras;
                  $scope.papeis = papeis;
                  $scope.estados = estados;
                  $scope.estadosCandidatura = estadosCandidatura;
                  $scope.simnao = this.simnao;
                  $scope.removeDate = this.UI.removeDate;
                  $scope.checkingSlug = false;
                  $scope.dateOptions = {
                    dataCandidatura: {format: 'DD/MM/YYYY'},
                    dataInicio: {format: 'DD/MM/YYYY'},
                    dataFim: {format: 'DD/MM/YYYY'}
                  };

                  $scope.auxEntidadeFinanciadora = {
                    selected: $scope.projeto.entidadeFinanciadora ? $scope.projeto.entidadeFinanciadora : null,
                    infiniteScroll: {numToAdd: 20, currentItems: 20}
                  };
                  $scope.auxPapel = {
                    selected: $scope.projeto.papel ? $scope.projeto.papel : null,
                    infiniteScroll: {numToAdd: 20, currentItems: 20}
                  };
                  $scope.auxEstado = {
                    selected: $scope.projeto.estado ? $scope.projeto.estado : null,
                    infiniteScroll: {numToAdd: 20, currentItems: 20}
                  };
                  $scope.auxEstadoCandidatura = {
                    selected: $scope.projeto.estadoCandidatura ? $scope.projeto.estadoCandidatura : null,
                    infiniteScroll: {numToAdd: 20, currentItems: 20}
                  };
                  $scope.auxInvestigador = {
                    selected: $scope.projeto.investigador ? $scope.projeto.investigador : null,
                    infiniteScroll: {numToAdd: 20, currentItems: 20}
                  };
                  $scope.auxCoInvestigador = {
                    selected: $scope.projeto.coInvestigador ? $scope.projeto.coInvestigador : null,
                    infiniteScroll: {numToAdd: 20, currentItems: 20}
                  };
                  $scope.auxAdoption = {
                    selected: $scope.projeto.commercialAdoptions ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
                    infiniteScroll: {numToAdd: 20, currentItems: 20}
                  };
                  $scope.auxPublicado = {
                    selected: $scope.projeto.publicado ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
                    infiniteScroll: {numToAdd: 20, currentItems: 20}
                  };
                  $scope.auxDestaque = {
                    selected: $scope.projeto.emDestaque ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
                    infiniteScroll: {numToAdd: 20, currentItems: 20}
                  };

                  // Infinite Scroll magic
                  $scope.addMoreItems = (infiniteScroll) => {
                    infiniteScroll.currentItems += infiniteScroll.numToAdd;
                  };

                  $scope.updateSlug = () => {
                    $scope.projeto.slug = this.ProjetoService.stringToSlug($scope.projeto.acronimo);
                  };

                  $scope.ok = () => {
                    if ($scope.auxInvestigador.selected && $scope.auxCoInvestigador.selected && $scope.auxInvestigador.selected.id === $scope.auxCoInvestigador.selected.id) {
                      this.UI.addToast("Investigador e co-investigador principal não podem ser iguais");
                      return;
                    }
                    if (!this.ProjetoService.isValidURL($scope.projeto.www)) {
                      this.UI.addToast("Endereço Web inválido");
                      return;
                    }
                    if (!this.ProjetoService.isValidSlug($scope.projeto.slug)) {
                      this.UI.addToast("Slug inválido, use apenas letras minúsculas, números e hífenes, sem espaços nem acentos.");
                      return;
                    }
                    // Check if slug exists
                    $scope.checkingSlug = true;
                    this.ProjetoService.checkExistingSlug($scope.projeto.slug, this.data.id).then((exists) => {
                      $scope.checkingSlug = false;
                      if (exists) {
                        this.UI.addToast("Este slug já existe para outro projeto");
                      } else {
                        $dialog.close($scope);
                      }
                    }).catch(err => {
                      $scope.checkingSlug = false;
                      this.UI.addToast("Erro de verificação de slug. Verifique a ligação");
                      console.log(err);
                    });
                  };

                  $scope.cancel = () => $scope.$dismiss('cancel');
                }]
              };

              this.UI.showDialog(options).then(res => {
                this.loaded = false;
                if (res) {
                  this.data.acronimo = res.projeto.acronimo;
                  this.data.titulo = res.projeto.titulo;
                  this.data.dataCandidatura = moment(res.projeto.dataCandidatura).isValid() ? moment(res.projeto.dataCandidatura).format() : null;
                  this.data.dataInicio = moment(res.projeto.dataInicio).isValid() ? moment(res.projeto.dataInicio).format() : null;
                  this.data.dataFim = moment(res.projeto.dataFim).isValid() ? moment(res.projeto.dataFim).format() : null;
                  this.data.www = res.projeto.www || null;
                  this.data.slug = res.projeto.slug;
                  this.data.publicado = res.auxPublicado.selected.value;
                  this.data.emDestaque = res.auxDestaque.selected.value || 0;

                  this.data.investigador = res.auxInvestigador.selected;
                  this.data.investigadorId = res.auxInvestigador.selected.id;
                  this.data.coInvestigador = res.auxCoInvestigador.selected;
                  this.data.coInvestigadorId = res.auxCoInvestigador.selected ? res.auxCoInvestigador.selected.id : null;
                  this.data.entidadeFinanciadora = res.auxEntidadeFinanciadora.selected;
                  this.data.entidadeFinanciadoraId = res.auxEntidadeFinanciadora.selected.id;
                  this.data.papel = res.auxPapel.selected;
                  this.data.papelId = res.auxPapel.selected.id;
                  this.data.estado = res.auxEstado.selected;
                  this.data.estadoId = res.auxEstado.selected.id;
                  this.data.estadoCandidatura = res.auxEstadoCandidatura.selected;
                  this.data.estadoCandidaturaId = res.auxEstadoCandidatura.selected.id;

                  this.data.commercialAdoptions = res.auxAdoption.selected.value;

                  this.data.atualizadoPorId = this.user.id;
                  this.data.atualizadoa = moment().format();

                  this.Projeto.upsert(this.data).$promise.then((res) => {
                    this.UI.addToast("Dados atualizados com sucesso");
                    this.loadData();
                  }).catch((error) => {
                    console.log(error);
                    this.UI.showAlert("Erro ao atualizar projeto. Verifique a ligação");
                    this.loaded = true;
                  });
                }
              });
            }).catch((error) => {
              wait.close();
              console.log(error);
              this.UI.addToast("Não foi possível ler Estados de Candidatura. Verifique a ligação");
            });
          }).catch((error) => {
            wait.close();
            console.log(error);
            this.UI.addToast("Não foi possível ler Estados. Verifique a ligação");
          });
        }).catch((error) => {
          wait.close();
          console.log(error);
          this.UI.addToast("Não foi possível ler Papéis. Verifique a ligação");
        });
      }).catch((error) => {
        wait.close();
        console.log(error);
        this.UI.addToast("Não foi possível ler Entidades. Verifique a ligação");
      });
    }).catch(error => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler Investigadores. Verifique a ligação");
    });
  };

  // Edit yes/no with extra data
  editInformacao = () => {
    let options = {
      size: 'lg',
      template: require('./informacao.dialog.html'),
      controller: ['$scope', ($scope) => {
        $scope.label = "Editar Informação Adicional";
        $scope.projeto = angular.copy(this.data);
        $scope.simnao = this.simnao;

        // Configuration for date picker data
        $scope.removeDate = this.UI.removeDate;
        $scope.dateOptions = {
          dataComunicacaoAvaliacao: {format: 'DD/MM/YYYY'}
        };

        $scope.auxDifferent = {
          selected: $scope.projeto.differentInstitutionsAuthors ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };
        $scope.auxDevelopingCountries = {
          selected: $scope.projeto.developingCountries ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };

        // Infinite Scroll magic
        $scope.addMoreItems = (infiniteScroll) => {
          infiniteScroll.currentItems += infiniteScroll.numToAdd;
        };

        $scope.ok = () => {
          $scope.$close($scope);
        };

        $scope.cancel = () => $scope.$dismiss('cancel');
      }]
    };

    this.UI.showDialog(options).then(res => {
      this.loaded = false;
      if (res) {
        this.data.codigoFinanciamento = res.projeto.codigoFinanciamento || null;
        this.data.orcamentoTotal = res.projeto.orcamentoTotal;
        this.data.orcamentoIsr = res.projeto.orcamentoIsr;
        this.data.notaQuantitativa =res.projeto.notaQuantitativa;
        this.data.dataComunicacaoAvaliacao = moment(res.projeto.dataComunicacaoAvaliacao).isValid() ? moment(res.projeto.dataComunicacaoAvaliacao).format() : null;
        this.data.observacoes = res.projeto.observacoes || null;

        // Update bool values
        this.data.differentInstitutionsAuthors = res.auxDifferent.selected.value;
        this.data.developingCountries = res.auxDevelopingCountries.selected.value;
        if (!this.data.developingCountries) this.data.developingCountriesText = null;
        else this.data.developingCountriesText = res.projeto.developingCountriesText;

        this.data.atualizadoPorId = this.user.id;
        this.data.atualizadoa = moment().format();

        this.Projeto.upsert(this.data).$promise.then((res) => {
          this.UI.addToast("Dados atualizados com sucesso");
          this.loadData();
        }).catch((error) => {
          console.log(error);
          this.UI.showAlert("Erro ao atualizar projeto. Verifique a ligação");
          this.loaded = true;
        });
      }
    });
  };

  // Edit yes/no with extra data
  editQuestoes = () => {
    let options = {
      size: 'lg',
      template: require('./questoes.dialog.html'),
      controller: ['$scope', ($scope) => {
        $scope.label = "Editar Informação Complementar";
        $scope.projeto = angular.copy(this.data);
        $scope.simnao = this.simnao;

        $scope.auxRelevant = {
          selected: $scope.projeto.relevantStakeholders ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };
        $scope.auxCitizen = {
          selected: $scope.projeto.citizenScienceApproach ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };
        $scope.auxPerformed = {
          selected: $scope.projeto.performedPublicConsultation ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };
        $scope.auxResource = {
          selected: $scope.projeto.resourceDeliverable ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };
        $scope.auxInternational = {
          selected: $scope.projeto.internationalCollaboration ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };

        // Infinite Scroll magic
        $scope.addMoreItems = (infiniteScroll) => {
          infiniteScroll.currentItems += infiniteScroll.numToAdd;
        };

        $scope.ok = () => {
          $scope.$close($scope);
        };

        $scope.cancel = () => $scope.$dismiss('cancel');
      }]
    };

    this.UI.showDialog(options).then(res => {
      this.loaded = false;
      if (res) {
        // Update bool values
        this.data.relevantStakeholders = res.auxRelevant.selected.value;
        this.data.citizenScienceApproach = res.auxCitizen.selected.value;
        this.data.performedPublicConsultation = res.auxPerformed.selected.value;
        this.data.resourceDeliverable = res.auxResource.selected.value;
        this.data.internationalCollaboration = res.auxInternational.selected.value;
        // Remove text if bool values are false
        if (!this.data.relevantStakeholders) this.data.relevantStakeholdersText = null;
        else this.data.relevantStakeholdersText = res.projeto.relevantStakeholdersText;
        if (!this.data.citizenScienceApproach) this.data.citizenScienceApproachText = null;
        else this.data.citizenScienceApproachText = res.projeto.citizenScienceApproachText;
        if (!this.data.performedPublicConsultation) this.data.performedPublicConsultationText = null;
        else this.data.performedPublicConsultationText = res.projeto.performedPublicConsultationText;
        if (!this.data.resourceDeliverable) this.data.resourceDeliverableText = null;
        else this.data.resourceDeliverableText = res.projeto.resourceDeliverableText;
        if (!this.data.internationalCollaboration) this.data.internationalCollaborationText = null;
        else this.data.internationalCollaborationText = res.projeto.internationalCollaborationText;

        this.data.atualizadoPorId = this.user.id;
        this.data.atualizadoa = moment().format();

        this.Projeto.upsert(this.data).$promise.then((res) => {
          this.UI.addToast("Dados atualizados com sucesso");
          this.loadData();
        }).catch((error) => {
          console.log(error);
          this.UI.showAlert("Erro ao atualizar projeto. Verifique a ligação");
          this.loaded = true;
        });
      }
    });
  };

  // Multiple data
  // Elementos - Equipa
  elementoModalOptions = (data, edit) => {
    let defer = this.$q.defer();

    let elemento = {};
    let auxInvestigadorSelection = undefined;
    if (edit && data != null) {
      elemento = angular.copy(data);
      auxInvestigadorSelection = elemento.investigador;
    }
    let wait = this.UI.showWaiting();
    this.Investigador.find({}).$promise.then((investigadores) => {
      investigadores.sort((a, b) => a.nome.localeCompare(b.nome));
      wait.close();
      defer.resolve({
        size: 'lg',
        template: require('./../new/edit.equipa.dialog.html'),
        controller: ['$dialog', '$scope', (dialog, scope) => {
          scope.label = (edit ? "Editar" : "Novo") + " Membro de Equipa de Investigação";
          scope.elemento = elemento;
          scope.investigadores = investigadores;

          scope.auxInvestigador = {
            selected: auxInvestigadorSelection,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          scope.ok = () => {
            dialog.close(scope);
          };

          scope.cancel = () => {
            dialog.dismiss('cancel');
          };
        }]
      });
    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível ler investigadores. Verifique a sua ligação");
      defer.reject();
    });
    return defer.promise;
  };

  // Adicionar um novo elemento para projeto
  addElemento = () => {
    this.elementoModalOptions(null, false).then(options => {
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxInvestigador && ok.elemento) {
          this.elementosLoading = true;
          let item = angular.copy(ok.elemento);
          item.investigadorId = ok.auxInvestigador.selected.id;
          item.investigador = angular.copy(ok.auxInvestigador.selected);
          // Check if elemento is already there before creating
          this.ProjetoService.usedPartialDataForModel({projetoId: this.id, investigadorId: item.investigadorId}, this.ProjetoEquipa).then(res => {
            if (res.count > 0) { // Already exists
              this.UI.addToast("Membro da equipa já existe");
              this.elementosLoading = false;
            } else { // Create it
              this.ProjetoService.createMultipleData(this.ProjetoEquipa, [item], this.id, 'projetoId').then((x) => {
                this.UI.addToast("Membro adicionado com sucesso");
                this.getElementosForProjeto();
              }).catch(error => {
                this.elementosLoading = false;
                this.UI.addToast("Erro ao inserir investigador. Verifique a ligação");
                console.log(error);
              });
            }
          }).catch((error) => {
            this.elementosLoading = false;
            this.UI.addToast("Erro de criação. Verifique a ligação.");
            console.log(error);
          });
        }
      });
    }).catch(() => {}); // Already dealt with upstream
  };

  // Ask confirmation to delete elemento
  confirmDeleteElemento = (x) => {
    let title = "Remover Membro da Equipa";
    let warning = "Tem a certeza que pretende remover este investigador?";
    let instance = this.UI.showDialog({
      size: 'md',
      template: require('../../interface/modals/delete-selected.html'),
      controller: ['$scope', function ($scope) {
        $scope.title = title;
        $scope.message = warning;
        $scope.ok = function () {
          $scope.$close();
        };
        $scope.cancel = function () {
          $scope.$dismiss('cancel');
        };
      }]
    });

    instance.then(() => {
      this.removeElemento(x);
    }, (err) => {
      if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
        console.log(err);
    })
  };

  removeElemento = (x) => {
    this.elementosLoading = true;
    // Find again elemento to delete so we can update it
    this.ProjetoEquipa.findOne({
      filter: {
        where: {
          id: x.id
        }
      }
    }).$promise.then((elementoToRemove) => {

      // Remove data
      this.ProjetoEquipa.deleteById({
        id: elementoToRemove.id,
      }).$promise.then((r) => {
        this.UI.addToast("Membro da equipa removido com sucesso");
        this.getElementosForProjeto();
      });

    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível eliminar membro da equipa. Verifique se ainda existe.");
      this.getElementosForProjeto();
    });
  };

  getElementosForProjeto = () => {
    this.elementosLoading = true;
    let whereLiteral = {
      'ProjetoEquipa.projetoId': this.id
    };
    let where = {};
    Object.keys(this.optElemento.filter).forEach(f => {
      if (this.optElemento.filter[f])
        where[f] = this.optElemento.filter[f];
    });
    this.ProjetoEquipa.table({
      params: {
        fields: [
          'ProjetoEquipa.id as id',
          'ProjetoEquipa.projetoId as projetoId',
          'ProjetoEquipa.investigadorId as investigadorId',
          'ProjetoEquipa.dataCriacao as dataCriacao',
          'ProjetoEquipa.atualizadoa as atualizadoa',
          'ProjetoEquipa.criadoPorId as criadoPorId',
          'User.name as criadoPorName',
          'User2.name as atualizadoPorName',
          'Investigador.id as auxInvestigadorId',
          'Investigador.nome as auxInvestigadorNome'
        ],
        from: ['ProjetoEquipa', 'User', 'User', 'Investigador'],
        references: [undefined, 'ProjetoEquipa.criadoPorId', 'ProjetoEquipa.atualizadoPorId', 'ProjetoEquipa.investigadorId'],
        aliases: [null, null, 'User2', null],
        where: where,
        whereLiteral: whereLiteral,
        order: this.optElemento.order,
        sort: this.optElemento.sort,
        limit: this.optElemento.items,
        skip: (this.optElemento.page - 1) * this.optElemento.items,
      }
    }).$promise.then(res => {
      let page = this.optElemento.page;
      let items = this.optElemento.items;

      let total = res.count;

      this.optElemento.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optElemento.start - 1 + items) >= total) {
        this.optElemento.end = total;
      } else {
        this.optElemento.end = Number.parseInt(this.optElemento.start - 1 + items);
      }

      // Process sub-data
      res.data.forEach(x => {
        x.investigador = {
          id: x.auxInvestigadorId,
          nome: x.auxInvestigadorNome
        };
      });

      this.elementos = res.data;
      this.optElemento.total = total;
      this.elementosLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler membros de equipa de investigação. Verifique a ligação");
    });
  };

  elementoSort = keyname => {
    if (this.optElemento.order === keyname)
      this.optElemento.page = 1;
    this.optElemento.order = keyname;
    this.optElemento.sort = this.optElemento.sort === 'asc' ? 'desc' : 'asc';
    this.getElementosForProjeto();
  };

  elementoItem = val => {
    this.optElemento.items = val;
    this.optElemento.page = 1;
    this.getElementosForProjeto();
  };

  elementoPage = sum => {
    this.optElemento.page += sum;
    if (this.optElemento.page < 1)
      this.optElemento.page = 1;
    if (this.optElemento.page > Math.ceil(this.optElemento.total / this.optElemento.items))
      this.optElemento.page = Math.ceil(this.optElemento.total / this.optElemento.items);
    this.getElementosForProjeto();
  };

  viewElemento = x => {
    this.UI.showDialog({
      size: 'md',
      template: require('./elemento.info.dialog.html'),
      controller: ['$scope', function ($scope) {
        $scope.data = angular.copy(x);
        $scope.data.dataCriacao = moment($scope.data.dataCriacao).isValid() ? moment($scope.data.dataCriacao).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.data.atualizadoa = moment($scope.data.atualizadoa).isValid() ? moment($scope.data.atualizadoa).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.fechar = function () {
          $scope.$close();
        };
      }]
    });
  };


  // Área Interdisciplinar
  areasModalOptions = (data, edit) => {
    let defer = this.$q.defer();

    let area = {};
    let auxAreaSelection = undefined;
    if (edit && data != null) {
      area = angular.copy(data);
      auxAreaSelection = area.area;
    }
    let wait = this.UI.showWaiting();
    this.AreaInterdisciplinar.find({}).$promise.then((areas) => {
      wait.close();
      defer.resolve({
        size: 'lg',
        template: require('./../new/edit.area.dialog.html'),
        controller: ['$dialog', '$scope', (dialog, scope) => {
          scope.label = (edit ? "Editar" : "Nova") + " Área Interdisciplinar";
          scope.area = area;
          scope.areas = areas;

          scope.auxArea = {
            selected: auxAreaSelection,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          scope.ok = () => {
            dialog.close(scope);
          };

          scope.cancel = () => {
            dialog.dismiss('cancel');
          };
        }]
      });
    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível ler áreas interdisciplinares. Verifique a sua ligação");
      defer.reject();
    });
    return defer.promise;
  };

  // Adicionar um nova área para projeto
  addArea = () => {
    if (this.areas.length >= 3) {
      this.UI.addToast("Só é possível escolher até 3 áreas");
      return;
    }
    this.areasModalOptions(null, false).then(options => {
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxArea && ok.area) {
          this.areasLoading = true;
          let item = angular.copy(ok.area);
          item.areaId = ok.auxArea.selected.id;
          item.area = angular.copy(ok.auxArea.selected);
          // Check if area is already there before creating
          this.ProjetoService.usedPartialDataForModel({projetoId: this.id, areaId: item.areaId}, this.ProjetoAreaInterdisciplinar).then(res => {
            if (res.count > 0) { // Already exists
              this.UI.addToast("Área Interdisciplinar já existe");
              this.areasLoading = false;
            } else { // Create it
              this.ProjetoService.createMultipleData(this.ProjetoAreaInterdisciplinar, [item], this.id, 'projetoId').then((x) => {
                this.UI.addToast("Área Interdisciplinar adicionada com sucesso");
                this.getAreasForProjeto();
              }).catch(error => {
                this.areasLoading = false;
                this.UI.addToast("Erro ao inserir área. Verifique a ligação");
                console.log(error);
              });
            }
          }).catch((error) => {
            this.areasLoading = false;
            this.UI.addToast("Erro de criação. Verifique a ligação.");
            console.log(error);
          });
        }
      });
    }).catch(() => {}); // Already dealt with upstream
  };

  // Ask confirmation to delete entrada/saida
  confirmDeleteArea = (x) => {
    let title = "Eliminar Área Interdisciplinar";
    let warning = "Tem a certeza que pretende remover esta área interdisciplinar?";
    let instance = this.UI.showDialog({
      size: 'md',
      template: require('../../interface/modals/delete-selected.html'),
      controller: ['$scope', function ($scope) {
        $scope.title = title;
        $scope.message = warning;
        $scope.ok = function () {
          $scope.$close();
        };
        $scope.cancel = function () {
          $scope.$dismiss('cancel');
        };
      }]
    });

    instance.then(() => {
      this.removeArea(x);
    }, (err) => {
      if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
        console.log(err);
    })
  };

  removeArea = (x) => {
    this.areasLoading = true;
    // Find again area to delete so we can update it
    this.ProjetoAreaInterdisciplinar.findOne({
      filter: {
        where: {
          id: x.id
        }
      }
    }).$promise.then((areaToRemove) => {
      // Only for mandatory existing multiple data
      this.ProjetoAreaInterdisciplinar.count({
        fields: {id: true},
        where: {
          projetoId: this.id
        }
      }).$promise.then((res) => {
        if (res.count > 1) { // There are other areas still remaining

          // Remove data
          this.ProjetoAreaInterdisciplinar.deleteById({
            id: areaToRemove.id,
          }).$promise.then((r) => {
            this.UI.addToast("Área interdisciplinar removida com sucesso");
            this.getAreasForProjeto();
          });

        } else { // No other areas exist, can't remove
          this.areasLoading = false;
          this.UI.showAlert("Não foi possível apagar a área interdisciplinar porque tem que haver pelo menos 1 registo para o projeto");
        }
      }).catch((error) => {
        console.log(error);
        this.UI.addToast("Não foi possível consultar projeto. Verifique a ligação");
        this.getAreasForProjeto();
      });
    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível eliminar área interdisciplinar. Verifique se ainda existe.");
      this.getAreasForProjeto();
    });
  };

  getAreasForProjeto = () => {
    this.areasLoading = true;
    let whereLiteral = {
      'ProjetoAreaInterdisciplinar.projetoId': this.id
    };
    let where = {};
    Object.keys(this.optAreas.filter).forEach(f => {
      if (this.optAreas.filter[f])
        where[f] = this.optAreas.filter[f];
    });
    this.ProjetoAreaInterdisciplinar.table({
      params: {
        fields: [
          'ProjetoAreaInterdisciplinar.id as id',
          'ProjetoAreaInterdisciplinar.projetoId as projetoId',
          'ProjetoAreaInterdisciplinar.areaId as areaId',
          'ProjetoAreaInterdisciplinar.dataCriacao as dataCriacao',
          'ProjetoAreaInterdisciplinar.atualizadoa as atualizadoa',
          'ProjetoAreaInterdisciplinar.criadoPorId as criadoPorId',
          'User.name as criadoPorName',
          'User2.name as atualizadoPorName',
          'AreaInterdisciplinar.id as auxAreaId',
          'AreaInterdisciplinar.designacao as auxAreaDesignacao'
        ],
        from: ['ProjetoAreaInterdisciplinar', 'User', 'User', 'AreaInterdisciplinar'],
        references: [undefined, 'ProjetoAreaInterdisciplinar.criadoPorId', 'ProjetoAreaInterdisciplinar.atualizadoPorId', 'ProjetoAreaInterdisciplinar.areaId'],
        aliases: [null, null, 'User2', null],
        where: where,
        whereLiteral: whereLiteral,
        order: this.optAreas.order,
        sort: this.optAreas.sort,
        limit: this.optAreas.items,
        skip: (this.optAreas.page - 1) * this.optAreas.items,
      }
    }).$promise.then(res => {
      let page = this.optAreas.page;
      let items = this.optAreas.items;

      let total = res.count;

      this.optAreas.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optAreas.start - 1 + items) >= total) {
        this.optAreas.end = total;
      } else {
        this.optAreas.end = Number.parseInt(this.optAreas.start - 1 + items);
      }

      // Process sub-data
      res.data.forEach(x => {
        x.area = {
          id: x.auxAreaId,
          designacao: x.auxAreaDesignacao
        };
      });

      this.areas = res.data;
      this.optAreas.total = total;
      this.areasLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler áreas. Verifique a ligação");
    });
  };

  areaSort = keyname => {
    if (this.optAreas.order === keyname)
      this.optAreas.page = 1;
    this.optAreas.order = keyname;
    this.optAreas.sort = this.optAreas.sort === 'asc' ? 'desc' : 'asc';
    this.getAreasForProjeto();
  };

  areaItem = val => {
    this.optAreas.items = val;
    this.optAreas.page = 1;
    this.getAreasForProjeto();
  };

  areaPage = sum => {
    this.optAreas.page += sum;
    if (this.optAreas.page < 1)
      this.optAreas.page = 1;
    if (this.optAreas.page > Math.ceil(this.optAreas.total / this.optAreas.items))
      this.optAreas.page = Math.ceil(this.optAreas.total / this.optAreas.items);
    this.getAreasForProjeto();
  };

  viewArea = x => {
    this.UI.showDialog({
      size: 'md',
      template: require('./area.interdisciplinar.info.dialog.html'),
      controller: ['$scope', function ($scope) {
        $scope.data = angular.copy(x);
        $scope.data.dataCriacao = moment($scope.data.dataCriacao).isValid() ? moment($scope.data.dataCriacao).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.data.atualizadoa = moment($scope.data.atualizadoa).isValid() ? moment($scope.data.atualizadoa).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.fechar = function () {
          $scope.$close();
        };
      }]
    });
  };


  // Instituições
  instituicaoModalOptions = (data, edit) => {
    let defer = this.$q.defer();

    let instituicao = {};
    let auxInstituicaoSelection = undefined;
    if (edit && data != null) {
      instituicao = angular.copy(data);
      auxInstituicaoSelection = instituicao.instituicao;
    }
    let wait = this.UI.showWaiting();
    this.Instituicao.find({}).$promise.then((instituicoes) => {
      wait.close();
      defer.resolve({
        size: 'lg',
        template: require('./../new/edit.instituicao.dialog.html'),
        controller: ['$dialog', '$scope', (dialog, scope) => {
          scope.label = (edit ? "Editar" : "Nova") + " Instituição envolvida";
          scope.instituicao = instituicao;
          scope.instituicoes = instituicoes;

          scope.auxInstituicao = {
            selected: auxInstituicaoSelection,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          scope.ok = () => {
            dialog.close(scope);
          };

          scope.cancel = () => {
            dialog.dismiss('cancel');
          };
        }]
      });
    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível ler instituições. Verifique a sua ligação");
      defer.reject();
    });
    return defer.promise;
  };

  // Adicionar um nova instituicao para projeto
  addInstituicao = () => {
    this.instituicaoModalOptions(null, false).then(options => {
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxInstituicao && ok.instituicao) {
          this.instituicoesLoading = true;
          let item = angular.copy(ok.instituicao);
          item.instituicaoId = ok.auxInstituicao.selected.id;
          item.instituicao = angular.copy(ok.auxInstituicao.selected);
          // Check if instituicao is already there before creating
          this.ProjetoService.usedPartialDataForModel({projetoId: this.id, instituicaoId: item.instituicaoId}, this.ProjetoInstituicao).then(res => {
            if (res.count > 0) { // Already exists
              this.UI.addToast("Instituição já existe");
              this.instituicoesLoading = false;
            } else { // Create it
              this.ProjetoService.createMultipleData(this.ProjetoInstituicao, [item], this.id, 'projetoId').then((x) => {
                this.UI.addToast("Instituição adicionada com sucesso");
                this.getInstituicoesForProjeto();
              }).catch(error => {
                this.instituicoesLoading = false;
                this.UI.addToast("Erro ao inserir instituição. Verifique a ligação");
                console.log(error);
              });
            }
          }).catch((error) => {
            this.instituicoesLoading = false;
            this.UI.addToast("Erro de criação. Verifique a ligação.");
            console.log(error);
          });
        }
      });
    }).catch(() => {}); // Already dealt with upstream
  };

  // Ask confirmation to delete instituicao
  confirmDeleteInstituicao = (x) => {
    let title = "Eliminar Instituição";
    let warning = "Tem a certeza que pretende remover a participação desta instituição?";
    let instance = this.UI.showDialog({
      size: 'md',
      template: require('../../interface/modals/delete-selected.html'),
      controller: ['$scope', function ($scope) {
        $scope.title = title;
        $scope.message = warning;
        $scope.ok = function () {
          $scope.$close();
        };
        $scope.cancel = function () {
          $scope.$dismiss('cancel');
        };
      }]
    });

    instance.then(() => {
      this.removeInstituicao(x);
    }, (err) => {
      if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
        console.log(err);
    })
  };

  removeInstituicao = (x) => {
    this.instituicoesLoading = true;
    // Find again instituicao to delete so we can update it
    this.ProjetoInstituicao.findOne({
      filter: {
        where: {
          id: x.id
        }
      }
    }).$promise.then((instituicaoToRemove) => {

      // Remove data
      this.ProjetoInstituicao.deleteById({
        id: instituicaoToRemove.id,
      }).$promise.then((r) => {
        this.UI.addToast("Instituição removida com sucesso");
        this.getInstituicoesForProjeto();
      });

    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível eliminar instituição. Verifique se ainda existe.");
      this.getInstituicoesForProjeto();
    });
  };

  getInstituicoesForProjeto = () => {
    this.instituicoesLoading = true;
    let whereLiteral = {
      'ProjetoInstituicao.projetoId': this.id
    };
    let where = {};
    Object.keys(this.optInstituicao.filter).forEach(f => {
      if (this.optInstituicao.filter[f])
        where[f] = this.optInstituicao.filter[f];
    });
    this.ProjetoInstituicao.table({
      params: {
        fields: [
          'ProjetoInstituicao.id as id',
          'ProjetoInstituicao.projetoId as projetoId',
          'ProjetoInstituicao.instituicaoId as instituicaoId',
          'ProjetoInstituicao.dataCriacao as dataCriacao',
          'ProjetoInstituicao.atualizadoa as atualizadoa',
          'ProjetoInstituicao.criadoPorId as criadoPorId',
          'User.name as criadoPorName',
          'User2.name as atualizadoPorName',
          'Instituicao.id as auxInstituicaoId',
          'Instituicao.designacao as auxInstituicaoDesignacao',
          'Pais.nome as auxPaisNome'
        ],
        from: ['ProjetoInstituicao', 'User', 'User', 'Instituicao', 'Pais'],
        referencesOrigin: [undefined, undefined, undefined, undefined, 'Pais.id'],
        references: [undefined, 'ProjetoInstituicao.criadoPorId', 'ProjetoInstituicao.atualizadoPorId', 'ProjetoInstituicao.instituicaoId', 'Instituicao.paisId'],
        aliases: [null, null, 'User2', null, null],
        where: where,
        whereLiteral: whereLiteral,
        order: this.optInstituicao.order,
        sort: this.optInstituicao.sort,
        limit: this.optInstituicao.items,
        skip: (this.optInstituicao.page - 1) * this.optInstituicao.items,
      }
    }).$promise.then(res => {
      let page = this.optInstituicao.page;
      let items = this.optInstituicao.items;

      let total = res.count;

      this.optInstituicao.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optInstituicao.start - 1 + items) >= total) {
        this.optInstituicao.end = total;
      } else {
        this.optInstituicao.end = Number.parseInt(this.optInstituicao.start - 1 + items);
      }

      // Process sub-data
      res.data.forEach(x => {
        x.instituicao = {
          id: x.auxInstituicaoId,
          designacao: x.auxInstituicaoDesignacao,
          pais: x.auxInstituicaoPais
        };
      });

      this.instituicoes = res.data;
      this.optInstituicao.total = total;
      this.instituicoesLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler instituições. Verifique a ligação");
    });
  };

  instituicaoSort = keyname => {
    if (this.optInstituicao.order === keyname)
      this.optInstituicao.page = 1;
    this.optInstituicao.order = keyname;
    this.optInstituicao.sort = this.optInstituicao.sort === 'asc' ? 'desc' : 'asc';
    this.getInstituicoesForProjeto();
  };

  instituicaoItem = val => {
    this.optInstituicao.items = val;
    this.optInstituicao.page = 1;
    this.getInstituicoesForProjeto();
  };

  instituicaoPage = sum => {
    this.optInstituicao.page += sum;
    if (this.optInstituicao.page < 1)
      this.optInstituicao.page = 1;
    if (this.optInstituicao.page > Math.ceil(this.optInstituicao.total / this.optInstituicao.items))
      this.optInstituicao.page = Math.ceil(this.optInstituicao.total / this.optInstituicao.items);
    this.getInstituicoesForProjeto();
  };

  viewInstituicao = x => {
    this.UI.showDialog({
      size: 'md',
      template: require('./instituicao.info.dialog.html'),
      controller: ['$scope', function ($scope) {
        $scope.data = angular.copy(x);
        $scope.data.dataCriacao = moment($scope.data.dataCriacao).isValid() ? moment($scope.data.dataCriacao).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.data.atualizadoa = moment($scope.data.atualizadoa).isValid() ? moment($scope.data.atualizadoa).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.fechar = function () {
          $scope.$close();
        };
      }]
    });
  };


  // Grupos de Investigação
  grupoInvestigacaoModalOptions = (data, edit) => {
    let defer = this.$q.defer();

    let grupo = {};
    let auxGrupoInvestigacaoSelection = undefined;
    if (edit && data != null) {
      grupo = angular.copy(data);
      auxGrupoInvestigacaoSelection = grupo.grupo;
    }
    let wait = this.UI.showWaiting();
    this.GrupoInvestigacao.find({}).$promise.then((gruposInvestigacao) => {
      wait.close();
      defer.resolve({
        size: 'lg',
        template: require('./../new/edit.grupo.investigacao.dialog.html'),
        controller: ['$dialog', '$scope', (dialog, scope) => {
          scope.label = (edit ? "Editar" : "Adicionar") + " Grupo de Investigação";
          scope.grupo = grupo;
          scope.grupos = gruposInvestigacao;

          scope.auxGrupoInvestigacao = {
            selected: auxGrupoInvestigacaoSelection,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          scope.ok = () => {
            dialog.close(scope);
          };

          scope.cancel = () => {
            dialog.dismiss('cancel');
          };
        }]
      });
    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível ler grupos de investigação. Verifique a sua ligação");
      defer.reject();
    });
    return defer.promise;
  };

  // Adicionar um novo grupo de investigação para projeto
  addGrupoInvestigacao = () => {
    this.grupoInvestigacaoModalOptions(null, false).then(options => {
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxGrupoInvestigacao && ok.grupo) {
          this.gruposInvestigacaoLoading = true;
          let item = angular.copy(ok.grupo);
          item.grupoInvestigacaoId = ok.auxGrupoInvestigacao.selected.id;
          item.grupo = angular.copy(ok.auxGrupoInvestigacao.selected);
          // Check if grupo investigacao is already there before creating
          this.ProjetoService.usedPartialDataForModel({projetoId: this.id, grupoInvestigacaoId: item.grupoInvestigacaoId}, this.ProjetoGrupoInvestigacao).then(res => {
            if (res.count > 0) { // Already exists
              this.UI.addToast("Grupo de Investigação já existe");
              this.gruposInvestigacaoLoading = false;
            } else { // Create it
              this.ProjetoService.createMultipleData(this.ProjetoGrupoInvestigacao, [item], this.id, 'projetoId').then((x) => {
                this.UI.addToast("Grupo de investigação adicionado com sucesso");
                this.getGruposInvestigacaoForProjeto();
              }).catch(error => {
                this.gruposInvestigacaoLoading = false;
                this.UI.addToast("Erro ao inserir grupo de investigação. Verifique a ligação");
                console.log(error);
              });
            }
          }).catch((error) => {
            this.gruposInvestigacaoLoading = false;
            this.UI.addToast("Erro de criação. Verifique a ligação.");
            console.log(error);
          });
        }
      });
    }).catch(() => {}); // Already dealt with upstream
  };

  // Ask confirmation to delete grupo investigação
  confirmDeleteGrupoInvestigacao = (x) => {
    let title = "Eliminar Grupo de Investigação";
    let warning = "Tem a certeza que pretende remover a associação ao grupo de investigação?";
    let instance = this.UI.showDialog({
      size: 'md',
      template: require('../../interface/modals/delete-selected.html'),
      controller: ['$scope', function ($scope) {
        $scope.title = title;
        $scope.message = warning;
        $scope.ok = function () {
          $scope.$close();
        };
        $scope.cancel = function () {
          $scope.$dismiss('cancel');
        };
      }]
    });

    instance.then(() => {
      this.removeGrupoInvestigacao(x);
    }, (err) => {
      if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
        console.log(err);
    })
  };

  removeGrupoInvestigacao = (x) => {
    this.gruposInvestigacaoLoading = true;
    // Find again grupo investigação to delete so we can update it
    this.ProjetoGrupoInvestigacao.findOne({
      filter: {
        where: {
          id: x.id
        }
      }
    }).$promise.then((grupoInvestigacaoToRemove) => {

      // Remove data
      this.ProjetoGrupoInvestigacao.deleteById({
        id: grupoInvestigacaoToRemove.id,
      }).$promise.then((r) => {
        this.UI.addToast("Grupo de Investigação removido com sucesso");
        this.getGruposInvestigacaoForProjeto();
      });

    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível eliminar grupo. Verifique se ainda existe.");
      this.getGruposInvestigacaoForProjeto();
    });
  };

  getGruposInvestigacaoForProjeto = () => {
    this.gruposInvestigacaoLoading = true;
    let whereLiteral = {
      'ProjetoGrupoInvestigacao.projetoId': this.id
    };
    let where = {};
    Object.keys(this.optGrupoInvestigacao.filter).forEach(f => {
      if (this.optGrupoInvestigacao.filter[f])
        where[f] = this.optGrupoInvestigacao.filter[f];
    });
    this.ProjetoGrupoInvestigacao.table({
      params: {
        fields: [
          'ProjetoGrupoInvestigacao.id as id',
          'ProjetoGrupoInvestigacao.projetoId as projetoId',
          'ProjetoGrupoInvestigacao.grupoInvestigacaoId as grupoInvestigacaoId',
          'ProjetoGrupoInvestigacao.dataCriacao as dataCriacao',
          'ProjetoGrupoInvestigacao.atualizadoa as atualizadoa',
          'ProjetoGrupoInvestigacao.criadoPorId as criadoPorId',
          'User.name as criadoPorName',
          'User2.name as atualizadoPorName',
          'GrupoInvestigacao.id as auxGrupoInvestigacaoId',
          'GrupoInvestigacao.designacao as auxGrupoInvestigacaoDesignacao',
          'GrupoInvestigacao.descricao as auxGrupoInvestigacaoDescricao',
        ],
        from: ['ProjetoGrupoInvestigacao', 'User', 'User', 'GrupoInvestigacao'],
        referencesOrigin: [undefined, undefined, undefined, undefined],
        references: [undefined, 'ProjetoGrupoInvestigacao.criadoPorId', 'ProjetoGrupoInvestigacao.atualizadoPorId', 'ProjetoGrupoInvestigacao.grupoInvestigacaoId'],
        aliases: [null, null, 'User2', null, null],
        where: where,
        whereLiteral: whereLiteral,
        order: this.optGrupoInvestigacao.order,
        sort: this.optGrupoInvestigacao.sort,
        limit: this.optGrupoInvestigacao.items,
        skip: (this.optGrupoInvestigacao.page - 1) * this.optGrupoInvestigacao.items,
      }
    }).$promise.then(res => {
      let page = this.optGrupoInvestigacao.page;
      let items = this.optGrupoInvestigacao.items;

      let total = res.count;

      this.optGrupoInvestigacao.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optGrupoInvestigacao.start - 1 + items) >= total) {
        this.optGrupoInvestigacao.end = total;
      } else {
        this.optGrupoInvestigacao.end = Number.parseInt(this.optGrupoInvestigacao.start - 1 + items);
      }

      // Process sub-data
      res.data.forEach(x => {
        x.grupo = {
          id: x.auxGrupoInvestigacaoId,
          designacao: x.auxGrupoInvestigacaoDesignacao,
          descricao: x.auxGrupoInvestigacaoDescricao
        };
      });

      this.gruposInvestigacao = res.data;
      this.optGrupoInvestigacao.total = total;
      this.gruposInvestigacaoLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler grupos de investigação. Verifique a ligação");
    });
  };

  grupoInvestigacaoSort = keyname => {
    if (this.optGrupoInvestigacao.order === keyname)
      this.optGrupoInvestigacao.page = 1;
    this.optGrupoInvestigacao.order = keyname;
    this.optGrupoInvestigacao.sort = this.optGrupoInvestigacao.sort === 'asc' ? 'desc' : 'asc';
    this.getGruposInvestigacaoForProjeto();
  };

  grupoInvestigacaoItem = val => {
    this.optGrupoInvestigacao.items = val;
    this.optGrupoInvestigacao.page = 1;
    this.getGruposInvestigacaoForProjeto();
  };

  grupoInvestigacaoPage = sum => {
    this.optGrupoInvestigacao.page += sum;
    if (this.optGrupoInvestigacao.page < 1)
      this.optGrupoInvestigacao.page = 1;
    if (this.optGrupoInvestigacao.page > Math.ceil(this.optGrupoInvestigacao.total / this.optGrupoInvestigacao.items))
      this.optGrupoInvestigacao.page = Math.ceil(this.optGrupoInvestigacao.total / this.optGrupoInvestigacao.items);
    this.getGruposInvestigacaoForProjeto();
  };

  viewGrupoInvestigacao = x => {
    this.UI.showDialog({
      size: 'md',
      template: require('./grupo.investigacao.info.dialog.html'),
      controller: ['$scope', function ($scope) {
        $scope.data = angular.copy(x);
        $scope.data.dataCriacao = moment($scope.data.dataCriacao).isValid() ? moment($scope.data.dataCriacao).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.data.atualizadoa = moment($scope.data.atualizadoa).isValid() ? moment($scope.data.atualizadoa).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.fechar = function () {
          $scope.$close();
        };
      }]
    });
  };


  // Impactos
  // Edit Impacto Ambiental, Económico, Social
  editImpactos = () => {
    let options = {
      size: 'lg',
      template: require('./impactos.dialog.html'),
      controller: ['$scope', ($scope) => {
        $scope.label = "Editar Impacto Ambiental, Económico, Social";
        $scope.impacto = angular.copy(this.data.impacto);
        $scope.simnao = this.simnao;

        $scope.auxImpactoAmbiental = {
          selected: $scope.impacto.ambiental ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };
        $scope.auxImpactoEconomico = {
          selected: $scope.impacto.economico ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };
        $scope.auxImpactoSocial = {
          selected: $scope.impacto.social ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };
        $scope.auxImpactoPolicyInfluence = {
          selected: $scope.impacto.policyInfluence ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };

        // Infinite Scroll magic
        $scope.addMoreItems = (infiniteScroll) => {
          infiniteScroll.currentItems += infiniteScroll.numToAdd;
        };

        $scope.ok = () => {
          $scope.$close($scope);
        };

        $scope.cancel = () => $scope.$dismiss('cancel');
      }]
    };

    this.UI.showDialog(options).then(ok => {
      this.loaded = false;

      // Ambiental
      if (ok.auxImpactoAmbiental.selected.value) {
        this.data.impacto.ambiental = ok.impacto.ambiental;
      } else {
        this.data.impacto.ambiental = null;
      }
      // Económico
      if (ok.auxImpactoEconomico.selected.value) {
        this.data.impacto.economico = ok.impacto.economico;
      } else {
        this.data.impacto.economico = null;
      }
      // Social
      if (ok.auxImpactoSocial.selected.value) {
        this.data.impacto.social = ok.impacto.social;
      } else {
        this.data.impacto.social = null;
      }
      // Policy influence
      if (ok.auxImpactoPolicyInfluence.selected.value) {
        this.data.impacto.policyInfluence = ok.impacto.policyInfluence;
      } else {
        this.data.impacto.policyInfluence = null;
      }

      this.data.impacto.observacoes = ok.impacto.observacoes || null;

      this.data.impacto.criadoPorId = this.user.id;
      this.data.impacto.dataCriacao = moment().format();

      this.Impacto.upsert(this.data.impacto).$promise.then(() => {
        this.UI.addToast("Impactos atualizados com sucesso");
        this.loadData();
      }).catch((error) => {
        console.log(error);
        this.UI.showAlert("Erro ao atualizar impactos. Verifique a ligação");
        this.loaded = true;
      });
    });
  };

  //Impactos ODS
  impactosOdsModalOptions = (data, edit) => {
    let defer = this.$q.defer();

    let ods = {};
    let auxOdsSelection = undefined;
    if (edit && data != null) {
      ods = angular.copy(data);
      auxOdsSelection = ods.ods;
    }
    let wait = this.UI.showWaiting();
    this.Ods.find({}).$promise.then((externalData) => {
      wait.close();
      defer.resolve({
        size: 'lg',
        template: require('./../new/impacto.dialog.html'),
        controller: ['$dialog', '$scope', (dialog, scope) => {
          scope.label = (edit ? "Editar" : "Novo") + " Impacto ODS";
          scope.ods = ods;
          scope.externalData = externalData;
          scope.tipo = 'ODS';

          scope.auxOds = {
            selected: auxOdsSelection,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          scope.ok = () => {
            dialog.close(scope);
          };

          scope.cancel = () => {
            dialog.dismiss('cancel');
          };
        }]
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler Impactos ODS. Verifique a sua ligação");
      defer.reject();
    });
    return defer.promise;
  };

  // Adicionar um novo ODS para impacto
  addImpactoOds = () => {
    this.impactosOdsModalOptions(null, false).then(options => {
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxOds && ok.ods) {
          this.impactosOdsLoading = true;
          let item = angular.copy(ok.ods);
          item.odsId = ok.auxOds.selected.id;
          item.ods = angular.copy(ok.auxOds.selected);
          // Check if ODS is already there before creating
          this.ProjetoService.usedPartialDataForModel({impactoId: this.data.impactoId, odsId: item.odsId}, this.ImpactoOds).then(res => {
            if (res.count > 0) { // Already exists
              this.UI.addToast("Impacto ODS já existe");
              this.impactosOdsLoading = false;
            } else { // Create it
              this.ProjetoService.createMultipleData(this.ImpactoOds, [item], this.data.impactoId, 'impactoId').then(() => {
                this.UI.addToast("ODS adicionado com sucesso");
                this.getImpactosOdsForImpacto();
              }).catch(error => {
                this.impactosOdsLoading = false;
                this.UI.addToast("Erro ao inserir ODS. Verifique a ligação");
                console.log(error);
              });
            }
          }).catch((error) => {
            this.impactosOdsLoading = false;
            this.UI.addToast("Erro de criação. Verifique a ligação.");
            console.log(error);
          });
        }
      });
    }).catch(() => {}); // Already dealt with upstream
  };

  // Ask confirmation to delete ODS
  confirmDeleteImpactoOds = (x) => {
    let title = "Eliminar Impacto ODS";
    let warning = "Tem a certeza que pretende remover este impacto ODS?";
    let instance = this.UI.showDialog({
      size: 'md',
      template: require('../../interface/modals/delete-selected.html'),
      controller: ['$scope', function ($scope) {
        $scope.title = title;
        $scope.message = warning;
        $scope.ok = function () {
          $scope.$close();
        };
        $scope.cancel = function () {
          $scope.$dismiss('cancel');
        };
      }]
    });

    instance.then(() => {
      this.removeImpactoOds(x);
    }, (err) => {
      if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
        console.log(err);
    })
  };

  removeImpactoOds = (x) => {
    this.impactosOdsLoading = true;
    // Find again impacto ods to delete, so we can update it
    this.ImpactoOds.findOne({
      filter: {
        where: {
          id: x.id
        }
      }
    }).$promise.then((impactoOdsToRemove) => {
      // Only for mandatory existing multiple data

      // Remove data
      this.ImpactoOds.deleteById({
        id: impactoOdsToRemove.id,
      }).$promise.then(() => {
        this.UI.addToast("Impacto ODS removido com sucesso");
        this.getImpactosOdsForImpacto();
      });

    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível eliminar impacto ODS. Verifique se ainda existe.");
      this.getImpactosOdsForImpacto();
    });
  };

  getImpactosOdsForImpacto = () => {
    this.impactosOdsLoading = true;
    let whereLiteral = {
      'ImpactoOds.impactoId': this.data.impactoId
    };
    let where = {};
    Object.keys(this.optImpactosOds.filter).forEach(f => {
      if (this.optImpactosOds.filter[f])
        where[f] = this.optImpactosOds.filter[f];
    });
    this.ImpactoOds.table({
      params: {
        fields: [
          'ImpactoOds.id as id',
          'ImpactoOds.impactoId as impactoId',
          'ImpactoOds.odsId as odsId',
          'ImpactoOds.dataCriacao as dataCriacao',
          'User.name as criadoPor',
          'Ods.id as auxOdsId',
          'Ods.designacao as auxOdsDesignacao'
        ],
        from: ['ImpactoOds', 'User', 'Ods'],
        references: [undefined, 'ImpactoOds.criadoPorId', 'ImpactoOds.odsId'],
        where: where,
        whereLiteral: whereLiteral,
        order: this.optImpactosOds.order,
        sort: this.optImpactosOds.sort,
        limit: this.optImpactosOds.items,
        skip: (this.optImpactosOds.page - 1) * this.optImpactosOds.items,
      }
    }).$promise.then(res => {
      let page = this.optImpactosOds.page;
      let items = this.optImpactosOds.items;

      let total = res.count;

      this.optImpactosOds.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optImpactosOds.start - 1 + items) >= total) {
        this.optImpactosOds.end = total;
      } else {
        this.optImpactosOds.end = Number.parseInt(this.optImpactosOds.start - 1 + items);
      }

      // Process sub-data
      res.data.forEach(x => {
        x.ods = {
          id: x.auxOdsId,
          designacao: x.auxOdsDesignacao
        };
      });

      this.impactosOds = res.data;
      this.optImpactosOds.total = total;
      this.impactosOdsLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler ODS. Verifique a ligação");
    });
  };

  impactoOdsSort = keyname => {
    if (this.optImpactosOds.order === keyname)
      this.optImpactosOds.page = 1;
    this.optImpactosOds.order = keyname;
    this.optImpactosOds.sort = this.optImpactosOds.sort === 'asc' ? 'desc' : 'asc';
    this.getImpactosOdsForImpacto();
  };

  impactoOdsItem = val => {
    this.optImpactosOds.items = val;
    this.optImpactosOds.page = 1;
    this.getImpactosOdsForImpacto();
  };

  impactoOdsPage = sum => {
    this.optImpactosOds.page += sum;
    if (this.optImpactosOds.page < 1)
      this.optImpactosOds.page = 1;
    if (this.optImpactosOds.page > Math.ceil(this.optImpactosOds.total / this.optImpactosOds.items))
      this.optImpactosOds.page = Math.ceil(this.optImpactosOds.total / this.optImpactosOds.items);
    this.getImpactosOdsForImpacto();
  };

  viewImpactoOds = x => {
    this.UI.showDialog({
      size: 'md',
      template: require('./impacto.ods.info.dialog.html'),
      controller: ['$scope', function ($scope) {
        $scope.data = angular.copy(x);
        $scope.data.dataCriacao = moment($scope.data.dataCriacao).format('DD/MM/YYYY HH:mm:ss');
        $scope.fechar = function () {
          $scope.$close();
        };
      }]
    });
  };

  // Permissions
  // read: (ownPermission, allowAll, adminPermission, users)
  // edit: (ownPermission, allowOwn, adminPermission, users)
  canReadGeneral = () => this.ProjetoService.canRead('projetoRead', true, 'projetoReadAny', this.ProjetoService.getEquipaUserId(this.data));
  canEditGeneral = () => this.ProjetoService.canEdit('projetoEdit', true, 'projetoEditAny', this.ProjetoService.getEquipaUserId(this.data));

  canReadAdicional = () => this.ProjetoService.canRead('projetoReadAdicional', true, 'projetoReadAdicionalAny', this.ProjetoService.getEquipaUserId(this.data));
  canEditAdicional = () => this.ProjetoService.canEdit('projetoEditAdicional', true, 'projetoEditAdicionalAny', this.ProjetoService.getEquipaUserId(this.data));

  canReadEquipa = () => this.ProjetoService.canRead('projetoReadEquipa', true, 'projetoReadEquipaAny', this.ProjetoService.getEquipaUserId(this.data));
  canEditEquipa = () => this.ProjetoService.canEdit('projetoEditEquipa', true, 'projetoEditEquipaAny', this.ProjetoService.getEquipaUserId(this.data));

  canReadComplementar = () => this.ProjetoService.canRead('projetoReadComplementar', true, 'projetoReadComplementarAny', this.ProjetoService.getEquipaUserId(this.data));
  canEditComplementar = () => this.ProjetoService.canEdit('projetoEditComplementar', true, 'projetoEditComplementarAny', this.ProjetoService.getEquipaUserId(this.data));

  canReadInstituicao = () => this.ProjetoService.canRead('projetoReadInstituicao', true, 'projetoReadInstituicaoAny', this.ProjetoService.getEquipaUserId(this.data));
  canEditInstituicao = () => this.ProjetoService.canEdit('projetoEditInstituicao', true, 'projetoEditInstituicaoAny', this.ProjetoService.getEquipaUserId(this.data));

  canReadGrupoInvestigacao = () => this.ProjetoService.canRead('projetoReadGrupoInvestigacao', true, 'projetoReadGrupoInvestigacaoAny', this.ProjetoService.getEquipaUserId(this.data));
  canEditGrupoInvestigacao = () => this.ProjetoService.canEdit('projetoEditGrupoInvestigacao', true, 'projetoEditGrupoInvestigacaoAny', this.ProjetoService.getEquipaUserId(this.data));

  canReadAreaInterdisciplinar = () => this.ProjetoService.canRead('projetoReadAreaInterdisciplinar', true, 'projetoReadAreaInterdisciplinarAny', this.ProjetoService.getEquipaUserId(this.data));
  canEditAreaInterdisciplinar = () => this.ProjetoService.canEdit('projetoEditAreaInterdisciplinar', true, 'projetoEditAreaInterdisciplinarAny', this.ProjetoService.getEquipaUserId(this.data));

  canReadImpacto = () => this.ProjetoService.canRead('projetoReadImpacto', true, 'projetoReadImpactoAny', this.ProjetoService.getEquipaUserId(this.data));
  canEditImpacto = () => this.ProjetoService.canEdit('projetoEditImpacto', true, 'projetoEditImpactoAny', this.ProjetoService.getEquipaUserId(this.data));


  // Foto

  addImagem = () => {
    let options = {
      size: 'lg',
      template: require('./images.dialog.html'),
      controller: ['$scope', '$dialog', ($scope, $dialog) => {
        $scope.images = {};
        $scope.label = "Editar imagem de projeto";
        $scope.newFileName = '';
        $scope.oldFileName = '';

        $scope.uuid = this.ProjetoService.generateUUID();

        $scope.uploader = new this.FileUploader({
          url: '/api/Upload/projects/upload',
          queueLimit: 1,
          formData: [
            {
              key: 'value'
            }
          ]
        });

        let filter = {
          name: 'verifyIMG',
          fn: function (item, options) {
            return item.type.indexOf("image/") !== -1;
          }
        };
        $scope.uploader.filters.push(filter);

        $scope.uploader.onAfterAddingFile = (item) => {
          let partes = item.file.name.split(".");
          $scope.newFileName = $scope.uuid + "." + partes[partes.length - 1];

          if ($scope.uploader.queue.length > 1)
            $scope.uploader.queue.splice(0, $scope.uploader.queue.splice.length - 1);
          $scope.oldFileName =  $scope.uploader.queue[0].file.name;
        };

        $scope.uploader.onWhenAddingFileFailed = (img) => {
          this.UI.addToast("Por favor, carregue uma imagem");
        };

        $scope.uploader.onErrorItem = (response, status, headers) => {
          this.UI.addToast("A imagem não foi carregada com sucesso");
        };

        $scope.uploader.onBeforeUploadItem = (item) => {
          item.file.name = $scope.newFileName;
        };

        $scope.ok = () => {
          $dialog.close($scope);
        };

        $scope.cancel = () => {
          $dialog.dismiss('cancel');
        };
      }]
    };

    let dialogCreate = this.UI.showDialog(options);

    dialogCreate.then((ok) => {
      if (ok.newFileName) {
        let wait = this.UI.showWaiting();
        this.Projeto.deleteImagem({id: this.data.id}).$promise.then(() => { // Delete previous
          this.Projeto.prototype$updateAttributes({id: this.data.id}, {imagem: ok.newFileName}).$promise.then(() => {
            if (ok.newFileName) {
              // File exists, upload it
              ok.uploader.uploadAll();
              this.loadData();
            } else {
              // No file, just update the list
              this.loadData();
            }
            wait.close();
            this.UI.addToast("Imagem adicionada com sucesso!");
          }).catch(err => {
            wait.close();
            this.UI.addToast("Erro a adicionar imagem.");
            console.log(err);
          });
        }).catch(error => {
          console.log(error);
          this.UI.addToast("Erro na substituição de imagem.");
        });
      }
    }).catch((error) => {
      if (error !== 'cancel' && error !== 'escape key press' && error !== 'backdrop click')
        console.log(error);
    });
  };

  confirmDeleteImagem = () => {
    let title = "Eliminar Imagem de Projeto";
    let warning = "Tem a certeza que pretende remover esta imagem de projeto?";
    let instance = this.UI.showDialog({
      size: 'md',
      template: require('../../interface/modals/delete-selected.html'),
      controller: ['$scope', function ($scope) {
        $scope.title = title;
        $scope.message = warning;
        $scope.ok = function () {
          $scope.$close();
        };
        $scope.cancel = function () {
          $scope.$dismiss('cancel');
        };
      }]
    });

    instance.then(() => {
      this.deleteImagem();
    }, (err) => {
      if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
        console.log(err);
    });
  };

  deleteImagem = () => {
    this.Projeto.findById({id : this.data.id}).$promise.then((res) => {
      if (res) {
        if (res.imagem) {
          this.Projeto.deleteImagem({id: this.data.id}).$promise.then(() => {
            this.UI.addToast("Imagem removida com sucesso");
            this.loadData();
          }).catch(error => {
            console.log(error);
            this.UI.showAlert("Erro na remoção de imagem. Verifique se tem permissões e/ou verifique a ligação");
          });
        } else {
          this.UI.addToast("Projeto sem imagem definida");
          this.loadData();
        }
      } else {
        this.UI.addToast("Imagem não encontrado. Verifique a ligação");
        this.loadData();
      }
    }).catch((error) => {
      console.log(error);
    });
  };


  // Anexos

  getAnexosForProjeto = () => {
    this.anexosLoading = true;
    this.ProjetoAnexo.find({
      filter: {
        where: {
          projetoId: this.data.id
        },
        include: 'tipoAnexo'
      }
    }).$promise.then(anexos => {

      anexos.forEach(doc => {
        this.$http.get('/api/upload/projects/files/' + doc.nome).then(
          result => {
            if (result.data != null && !result.data.hasOwnProperty('error')) {
              doc.info = result.data;
            }
          },
          err => {
            console.log(err);
          }
        );
      });

      this.anexos = anexos;
      this.anexosLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler anexos. Verifique a ligação");
    });
  };

  addAnexo = () => {
    let options = {
      size: 'lg',
      controller: 'ProjetoFileUploaderController',
      controllerAs: 'm',
      template: require('./files.dialog.html'),
      resolve: {
        pID: () => {
          return this.data.id;
        },
        file: () => {
          return undefined;
        }
      }
    };
    let dialog = this.UI.showDialog(options);
    dialog.then(res => {
      if (res) {
        this.getAnexosForProjeto();
        this.UI.addToast('Ficheiro carregado com sucesso');
      }
    });
  };


  // Ask confirmation to delete elemento
  confirmDeleteAnexo = (x) => {
    let title = "Remover Anexo";
    let warning = "Tem a certeza que pretende remover este anexo?";
    let instance = this.UI.showDialog({
      size: 'md',
      template: require('../../interface/modals/delete-selected.html'),
      controller: ['$scope', function ($scope) {
        $scope.title = title;
        $scope.message = warning;
        $scope.ok = function () {
          $scope.$close();
        };
        $scope.cancel = function () {
          $scope.$dismiss('cancel');
        };
      }]
    });

    instance.then(() => {
      this.removeAnexo(x);
    }, (err) => {
      if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
        console.log(err);
    })
  };

  removeAnexo = (x) => {
    this.anexosLoading = true;
    // Find again anexo to delete
    this.ProjetoAnexo.findOne({
      filter: {
        where: {
          id: x.id
        }
      }
    }).$promise.then((elementoToRemove) => {
      // Remove data
      this.ProjetoAnexo.deleteAnexo({
        id: elementoToRemove.id,
      }).$promise.then((r) => {
        this.UI.addToast("Anexo removido com sucesso");
        this.getAnexosForProjeto();
      }).catch(error => {
        this.UI.addToast("Erro ao remover anexo. Verifique a ligação.");
        console.log(error);
        this.getAnexosForProjeto();
      });
    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível eliminar anexo. Verifique se ainda existe.");
      this.getAnexosForProjeto();
    });
  };

  editInfoAnexo = (a) => {
    let wait = this.UI.showWaiting();
    this.TipoAnexo.find({
      filter: {
        where: {}
      }
    }).$promise.then((tiposAnexo) => {
      wait.close();
      let options = {
        size: 'lg',
        template: require('./info.anexo.dialog.html'),
        controller: ['$scope', ($scope) => {
          $scope.label = "Editar Informação de Anexo";
          $scope.anexo = angular.copy(a);
          $scope.tiposAnexo = tiposAnexo;

          $scope.auxTipo = {
            selected: $scope.anexo.tipoAnexoId ? $scope.tiposAnexo.find(x => x.id === $scope.anexo.tipoAnexoId) : undefined,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = () => {
            $scope.$close($scope);
          };

          $scope.cancel = () => $scope.$dismiss('cancel');
        }]
      };

      this.UI.showDialog(options).then(ok => {
        this.loaded = false;
        if (ok && ok.auxTipo && ok.auxTipo.selected) {
          this.ProjetoAnexo.prototype$updateAttributes({id: ok.anexo.id}, {
            tipoAnexoId: ok.auxTipo.selected.id,
            descricao: ok.anexo.descricao
          }).$promise.then(() => {
            this.UI.addToast("Dados atualizados com sucesso");
            this.loadData();
          }).catch(error => {
            console.log(error);
            this.UI.showAlert("Erro ao atualizar notícia. Verifique a ligação");
            this.loaded = true;
          });
        }
      }).catch(() => {});
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Erro na procura de tipos de anexo. Verifique a ligação");
    });
  };
}

ProjetoDetailsController.$inject = ['$http', '$q', '$state', '$scope', 'FileUploader', 'AuthenticationService', 'AuthorizationService', 'UIService', 'ProjetoService', 'Projeto', 'ProjetoEquipa', 'ProjetoInstituicao', 'ProjetoGrupoInvestigacao', 'ProjetoAreaInterdisciplinar', 'EntidadeFinanciadora', 'Investigador', 'Instituicao', 'GrupoInvestigacao', 'AreaInterdisciplinar', 'Papel', 'ProjetoEstado', 'ProjetoEstadoCandidatura', 'Impacto', 'ImpactoOds', 'Ods', 'Pais', 'ProjetoAnexo', 'TipoAnexo'];
